<template>
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-accent">
          <h4 class="mb-0 text-white fs-1vw">محدوده حوزه کاری</h4>
        </div>
        <div class="card-body d-flex justify-content-around">
          <div class="form-check" v-for="(workArea, index) in workAreas" :key="index">
            <input
                class="form-check-input"
                type="radio"
                :id="index"
                :value="workArea"
                v-model="jobQualification.work_area"
            />
            <label class="form-check-label" :for="index">{{ workArea }}</label>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {
      workAreas: {
        headquarters: 'دفتر مرکزی',
        factory: 'کارخانه',
        remote: 'دورکاری',
        variable: 'متغیر',
      }
    }
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    },
  }
}
</script>
